import { render, staticRenderFns } from "./ComplieHeaderMoreMenu.vue?vue&type=template&id=33015347&scoped=true"
import script from "./ComplieHeaderMoreMenu.vue?vue&type=script&lang=js"
export * from "./ComplieHeaderMoreMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieHeaderMoreMenu.vue?vue&type=style&index=0&id=33015347&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33015347",
  null
  
)

export default component.exports